import { Box, Typography, IconButton, Chip } from '@mui/material';
import { ArrowBack } from '@mui/icons-material';
import { useHistory } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import '../../theme/newPost.css';

interface PostHeaderProps {
  isEditMode: boolean;
  activeStep: number;
  totalSteps: number;
}

const PostHeader: React.FC<PostHeaderProps> = ({ isEditMode, activeStep, totalSteps }) => {
  const { t } = useTranslation();
  const history = useHistory();

  return (
    <div className="new-post-header">
      <div className="new-post-header-content">
        <Box sx={{ display: 'flex', alignItems: 'center' }}>
          <IconButton 
            onClick={() => history.push('/home')}
            className="new-post-back-button"
          >
            <ArrowBack />
          </IconButton>
          <Typography 
            variant="h6" 
            className="new-post-title"
          >
            {isEditMode ? t('edit_post.title') : t('new_post.title')}
          </Typography>
        </Box>
        
        <Chip 
          label={`${activeStep + 1}/${totalSteps}`}
          color="primary"
          size="small"
          sx={{ fontWeight: 'bold' }}
        />
      </div>
    </div>
  );
};

export default PostHeader;
